export enum RoutesMap {
    HOME = "/home",
    LOGIN = "/login",
    MAIN = "/main",
    MY_PROFILE = "/my-profile",

    /* ------------------------- VIEWS ADMIN ------------------------------- */
    COMPANIES = "/companies",
    USERS = "/users",
    SALES_DOCUMENT = "/sales-document",
    WAY_TO_PAY = "/way-to-pay",
    BRANCH_OFFICES = "/branch-offices",
    WAREHOUSE = "/warehouse",
    WAREHOUSE_DISABLED = "/warehouse-disabled",
    BUSSINES_AREA = "/bussines-area",
    TYPE_ATTRIBUTES = "/type-attributes",
    PRODUCT_ATTRIBUTES = "/product-attributes",
    PRODUCT_USAGE_ATTRIBUTES = "/product-usage-attributes",
    SPECIFIC_PRODUCT_ATTRIBUTES = "/specific-product-attributes",
    DETAIL_ATTRIBUTES = "/detail-attributes",
    SPECIFIC_PRODUCT_USES = "/specific-product-uses",
    CATEGORIES = "/categories",
    SUB_CATEGORIES = "/subcategories",
    SPECIFIC_SUB_CATEGORIES = "/specific-subcategories",
    TYPE_PRODUCTS = "/type-products",
    CLASSIFICATION_PRODUCTS = "/clasification-products",
    PRODUCTS = "/products",
    LIST_OF_PRODUCTS = "/list-of-products",
    PRICE_LIST = "/price-list",
    SUPPLIER_CUSTOMER = "/supplier-customer",
    SEARCHER_KFC = "/emision-v1",
    SEARCHER_V2 = "/searcher-v2",
    SEARCHER_V3 = "/searcher-v3",
    PREVIEW_DOCUMENT = "/preview-document/:id",
    SEGMENTS = "/segments",
    SALE_CHANNEL = "/sale-channel",
    SELLER = "/seller",
    PERMISSIONS_BY_USER = '/permissions-by-users',
    INTEGRATION_BY_USER = '/integration-by-users',
    IMPORT_ERP = '/import-erp',
    IMPORT_WAREHOUSE = '/import-warehouse-erp',
    IMPORT_BUSINESS_AREA = '/import-business-area-erp',
    IMPORT_WAY_TO_PAY = '/import-way-to-pay-erp',
    IMPORT_PRODUCT = '/import-product-erp',
    IMPORT_CATEGORY = '/import-category-erp',
    IMPORT_SUBCATEGORY = '/import-subcategory-erp',
    IMPORT_SPECIFIC_SUBCATEGORY = '/import-specific-subcategory',
    IMPORT_CUSTOMER = '/import-customer',
    IMPORT_SUPPLIER = '/import-supplier',
    IMPORT_BRANCH = '/import-branch',
    SHOPPING_CART_V3 = '/shopping-cart-v3',
    TICKET_LIST_V3 = '/ticket-list-v3',
    SALES_LIST = '/sales-list',
    NC_LIST = 'nc-list',
    DG_LIST = 'diapatch-guide-list',
    ADMIN_LIST = '/admin-list',
    INFORMATION = '/information',
    INITIAL_STEP_LIST = '/initial-step-list',
    PLANS_LIST = '/plans-list',
    PLAN_INITIAL_STEP_LIST = '/plan-initial-step-list/:key',
    IMPORT_LIST = '/import-list',
    SEARCHER_COMPANY = '/searcher-pedido',
    MY_ORDERS = '/my-orders',
    INTAKE_CART = '/intake-cart',
    PRODUCT_ENTRY_PREVIEW = '/product-entry/preview/:id',
    STOCK_PRODUCT = '/stock-product',
    ACCOUNT_RECEIVABLE = '/account-receivable',
    PAYMENT_ENTERED = 'payment-entered',
    CARTOLA = '/cartola',
    PRODUCT_COST_LIST = '/product-cost-list',
    CLIENT_ORDER_LIST = '/client-order-list',
    CLIENT_PREVIEW_TICKET = '/client-preview-ticket/:id',
    DRIVER_LIST = '/driver-list',
    PATENT_LIST = '/patent-list',
}